import React from 'react';
import { siteContent } from '../data/mock';
import { Button } from './ui/button';

export const Hero = () => {
  const { hero } = siteContent;

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToSelector = () => {
    document.getElementById('category-selector')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-stone-50 border-b border-stone-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Copy */}
          <div className="order-2 lg:order-1">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-stone-900 leading-tight">
              {hero.headline}
            </h1>
            <p className="mt-4 text-lg sm:text-xl text-stone-600">
              {hero.subheadline}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              {/* Mobile CTA */}
              <Button
                onClick={scrollToSelector}
                className="sm:hidden bg-emerald-700 hover:bg-emerald-800 text-white px-8 py-3 text-base font-medium h-auto"
              >
                See if this is for you ↓
              </Button>
              {/* Desktop CTA */}
              <Button
                onClick={scrollToContact}
                className="hidden sm:inline-flex bg-emerald-700 hover:bg-emerald-800 text-white px-8 py-3 text-base font-medium h-auto"
              >
                {hero.cta}
              </Button>
              <span className="text-stone-500 text-sm">
                {hero.microCopy}
              </span>
            </div>
            <p className="mt-4 text-stone-500 text-xs">
              {hero.clarification}
            </p>
          </div>
          
          {/* Visual - Architectural image with baked-in notification overlay */}
          <div className="order-1 lg:order-2 relative">
            <div className="relative overflow-hidden aspect-[4/3]">
              {/* Image with notification overlay baked in - edge to edge, no borders */}
              <img
                src={hero.image}
                alt="Calm architectural space with notification overlay"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
